import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { CreateClientPage } from "@/features/ventes/components/clients/CreateClientPage";

export const Route = createFileRoute("/_app/ventes/clients/create")({
  loader: requirePermission(PERMISSIONS.VENTES.CLIENTS.CREATE),
  staticData: {
    title: "Nouveau client",
    showInBreadcrumb: true,
  },
  component: CreateClientPage,
});
